import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {HttpResponse} from "@angular/common/http";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {lastValueFrom, Observable} from "rxjs";
import {NzMessageService} from "ng-zorro-antd/message";
import {PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-ap-preview",
    standalone: false,
    templateUrl: "./ap-preview.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./ap-preview.component.scss"
})
export class ApPreviewComponent implements OnInit, OnDestroy {
    constructor(
        private readonly api: PerFormaAPIService,
        private readonly sanitizer: DomSanitizer,
        private readonly message: NzMessageService
    ) {}

    summary =
        "This page is designed to show how the signatures will appear on a sample check document.<br />Both signatures are shown even if the sample check amount only requires one signature.<br />This is only to reflect that the positioning of the signatures is correct.<br /><br />";

    loading = true;
    loadError = false;
    previewUrl: SafeResourceUrl | null = null;
    private objectUrl: string | null = null;

    private readonly blobResponse = {observe: "response", responseType: "blob"} as {observe: "response"};

    async ngOnInit() {
        try {
            const resp = (await lastValueFrom(
                this.api.getApiAPCheckGetPreview(this.blobResponse) as unknown as Observable<HttpResponse<Blob>>
            )) as HttpResponse<Blob>;

            if (resp.body) {
                this.objectUrl = URL.createObjectURL(resp.body);
                this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${this.objectUrl}#zoom=page-fit`);
            }
        } catch (e) {
            console.error(e);
            this.loadError = true;
            this.message.error("Could not load the check preview.");
        } finally {
            this.loading = false;
        }
    }

    ngOnDestroy(): void {
        if (this.objectUrl) {
            URL.revokeObjectURL(this.objectUrl);
            this.objectUrl = null;
        }
    }
}
